import about from './en/about'
import product from './en/product'
import matpl from './en/p_matpl'
import pwmodule from './en/p_module'
import pwkit from './en/p_pwkit'
import qflow from './en/p_qflow'
import qstudio from './en/p_qstudio'
import allinone from './en/p_allinone'
import gpu from './en/download/pwmat'
import ls3df from './en/download/ls3df'
import potential from './en/download/potential'
import utility from './en/download/utility'
import more from './en/more'

export default{
  ...about,
  ...product,
  ...matpl,
  ...pwmodule,
  ...pwkit,
  ...qflow,
  ...qstudio,
  ...allinone,
  ...gpu,
  ...ls3df,
  ...potential,
  ...utility,
  ...more,
  language: {
    name: 'EN'
  },
  navbar: {
    Home:'Home',
    About:'about Us',
    CompanyProfile:'Company Profile',
    CompanyNews:'Product Overview',
    AcademicDemo: 'Academic Education Program',
    IndustryDemo: 'Industry Solutions',
    Customers: 'Our customers',
    ContactUs:'Contact Us',
    JoinUs:'Join us',
    product:'product',
    Solution:'Software and hardware integration',
    Forum:'forum',
    Video:'Video Tutorial',
    Download:'download',
    SoftWareDownload:'PWmat',
    PWmatGPU:'GPU version',
    PWmatDCU:'DCU version',
    PWmatCPU:'CPU version',
    PWmatWin:'Windows version',
    PWmatTry:'Request a Trial',
    PotentialDownload:'Pseudopotential',
    PWmatManual:'PWmat manual',
    PWmatzhVer:'Chinese version',
    PWmatenVer:'English version',
    QflowManual:'Q-Flow manual',
    QstudioManual:'Q-Studio manual',
    Course:'Resource Center',
    Tutorial:'Tutorials',
    CommonParameter:'Common Parameters Explained',
    TypicalLiterature:'Typical literature reproduction',
    PublishedPapers:'Published papers',
    ModuleClassroom:'Module small classroom',
    GettingStartedVideo:'Getting Started Tutorial Video',
    SpecialVideo:'Special course videos',
    SpecialVideo2:'Training Camp Special Course Video',
    SpecialVideo3:'Q-Studio Modeling Tips',
    BigVideo:'Expert lectures video',
    BigVideo2:'Expert lectures',
    BigVideo3:'LongXun forum',
    BigVideo4:'Longxun Seminar',
    BigVideo5:'Conference Report',
    More:'More',
    Log:'Update Log',
    BugLog: 'Bug Log',
    Paper:'Paper',

  },
  footer:{
    QuickLink:'Quick Links',
    FriendlyLink:'Friendly Links',
    Company:'Beijing Longxun Kuangteng Technology Co.',
    JoinUs:'Careers',
    Tutorials:'Tutorials',
    Trial:'Trial Version',
    forum: 'LongXun Forum',
    link01: 'Peking University New Materials',
    phone1: 'Sales Tel:',
    phone2: 'Market phone:',
    wechat: 'WeChat official account',
  },
  carousel:{
    title1:'First principles calculation software PWmat',
    subtitle1:'Electronic structure self-consistency, structure optimization, molecular dynamics, transition state calculation, and various module function modules based on PWmat',
    button1:'learn more',
    title2:'PWmat Features',
    title3:'Longxun Supercomputing Cloud Mcloud',
    subtitle3:'Pre-installed PWmat, Q-Flow, Q-Studio, PWkit and other open source software',
    button3:'Click to register Mcloud',
    title4:'Machine Learning Force Field Software MatPL',
    subtitle4:'MatPL is open source software under the GNU license for generating machine learning force fields with comparable accuracy to ab initio molecular dynamics.',
    title5:'PWmat graphical interface Q-Flow',
    subtitle5:'PWmat is a graphical task submission software that has functions such as calculation, data storage, data processing, and data display.',
    title6:'Modeling software Q-Studio',
    subtitle6:'Web-based online atomic-scale material modeling software with rich functions, which can be used by opening the browser',
    title7:'Atomic-scale materials intelligent computing all-in-one machine QStation',
    subtitle7:'Accurate modeling, intelligent combination, intelligent optimization, insight into physical properties, and map presentation',
  },
  home: {
    productlist: 'Product List',
    allinone: 'All-in-one',
    about: 'Supercomputing Cloud',
    mcloud: `Mcloud is a supercomputing cloud platform consisting of high-performance clusters and cloud desktops built by Longxun Kuangteng.
      The cloud platform integrates software such as PWmat, Q-Flow, Q-Studio and Lammps, and provides SaaS material simulation computing services.
      Users can complete registration independently. After registration, they can use software such as PWmat and rich GPU card time resources online.
      `,
    register: 'Click to register',
    resource: 'Resource Center',
    resourcecenter: `The Resource Center aims to provide users with rich learning resources and reference materials.
      The Resource Center brings together various forms of tutorials, including basic tutorials, case tutorials,
      module classes, excellent paper interpretations, video materials, etc.,
      to help users systematically master the required skills and knowledge from basic knowledge to advanced applications.
       Whether you are a novice or an experienced professional,
       the Resource Center can provide a suitable learning path to help users learn and improve effectively.`,
    click: 'Click to view',
    news: 'News',
    cooperate: 'Partners',
  }
}
